<template lang="pug">
#atividades-operacao
    card
        el-form(
            label-position='top',
            :rules='atividadesOperacaoRules',
            ref='atividadesOperacaoForm',
            :model='atividadesOperacaoForm'
        )

            .row(v-if='atividadeObrigatoria')
                .col(:span='24')
                    el-form-item.sem-margem
                        el-tooltip(
                            :content="$t('mensagens.operacao.formularioAtividade.atividadesMesmoTipo')",
                            :disabled='!desativarOpcao("agrícola")'
                        )
                            el-radio(
                                v-model='atividadesOperacaoForm.tipo',
                                label='agricola',
                                :disabled='desativarOpcao("agrícola")'
                            ) {{ $t("mensagens.operacao.formularioAtividade.agricola") }}
                        el-tooltip(
                            :content="$t('mensagens.operacao.formularioAtividade.atividadesMesmoTipo')",
                            :disabled='!desativarOpcao("pecuária")'
                        )
                            el-radio.espaco-radio(
                                v-model='atividadesOperacaoForm.tipo',
                                label='pecuaria',
                                :disabled='desativarOpcao("pecuária")'
                            ) {{ $t("mensagens.operacao.formularioAtividade.pecuaria") }}

            div(v-if='atividadesOperacaoForm.tipo === "agricola"')
                .row(style='margin-right: 45px')
                    .col
                        el-form-item(prop='idProduto')
                            template(slot='label')
                                span.label {{ $t("mensagens.operacao.formularioAtividade.produtoAtividade") }}

                        el-select.campo-extendido(
                            v-model='atividadesOperacaoForm.idProduto',
                            @change='changeProduct()'
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='option in produtosAgricolasOpcoes',
                                :key='option.id',
                                :label='option.nome',
                                :value='option.id'
                            )
                                | {{ option.nome }}
                    .col
                        el-form-item(prop='areaFinanciadaAgricola')
                            template(slot='label')
                                span.label {{ $t("mensagens.operacao.formularioAtividade.areaFinanciadaHa") }}

                        money.campo-extendido.el-input__inner(
                            v-model='atividadesOperacaoForm.areaFinanciadaAgricola',
                            v-bind='areaMask',
                            :placeholder="$t('mensagens.operacao.formularioAtividade.areaFinanciadaHa')"
                        )

                .row
                    .col(style='flex-grow: 3')
                        el-form-item(prop='inicioPlantio')
                            template(slot='label')
                                span.label.pb-10 {{ $t("mensagens.operacao.formularioAtividade.inicioPlantio") }}
                                span.label.pb-10(v-if='!isDateMandatory') {{ " " + $t("mensagens.operacao.formularioAtividade.campoOpcionalLabel")}}

                            el-date-picker.campo-extendido(
                                v-model='atividadesOperacaoForm.inicioPlantio',
                                type='date',
                                :placeholder="$t('mensagens.operacao.acoes.selecione')",
                                format='dd/MM/yyyy',
                                disabledDate=''
                            )
                    .col(style='flex-grow: 3')
                        el-form-item(prop='fimPlantio')
                            template(slot='label')
                                span.label.pb-10 {{ $t("mensagens.operacao.formularioAtividade.fimPlantio") }}
                                span.label.pb-10(v-if='!isDateMandatory') {{ " " + $t("mensagens.operacao.formularioAtividade.campoOpcionalLabel")}}

                            el-date-picker.campo-extendido(
                                v-model='atividadesOperacaoForm.fimPlantio',
                                type='date',
                                :placeholder="$t('mensagens.operacao.acoes.selecione')",
                                format='dd/MM/yyyy',
                                disabledDate=''
                            )
                    .col(style='flex-grow: 3')
                        el-form-item(prop='inicioColheita')
                            template(slot='label')
                                span.label.pb-10 {{ $t("mensagens.operacao.formularioAtividade.inicioColheita") }}
                                span.label.pb-10(v-if='!isDateMandatory') {{ " " + $t("mensagens.operacao.formularioAtividade.campoOpcionalLabel")}}

                            el-date-picker.campo-extendido(
                                v-model='atividadesOperacaoForm.inicioColheita',
                                type='date',
                                :placeholder="$t('mensagens.operacao.acoes.selecione')",
                                format='dd/MM/yyyy',
                                disabledDate=''
                            )
                    .col(style='flex-grow: 3')
                        el-form-item(prop='fimColheita')
                            template(slot='label')
                                span.label.pb-10 {{ $t("mensagens.operacao.formularioAtividade.fimColheita") }}
                                span.label.pb-10(v-if='!isDateMandatory') {{ " " + $t("mensagens.operacao.formularioAtividade.campoOpcionalLabel")}}

                            el-date-picker.campo-extendido(
                                v-model='atividadesOperacaoForm.fimColheita',
                                type='date',
                                :placeholder="$t('mensagens.operacao.acoes.selecione')",
                                format='dd/MM/yyyy',
                                disabledDate=''
                            )
                    .col.alinhar-icone(style='flex-grow: 0.2')
                        el-tooltip(:content="$t('mensagens.operacao.acoes.adicionar')", placement='top')
                            i.el-icon-circle-plus-outline.icone(
                                @click='adicionarProdutoAgricola'
                            )
            div(v-if='atividadesOperacaoForm.tipo === "pecuaria"')
                .row
                    .col(style='flex-grow: 3')
                        el-form-item(prop='idProduto')
                            template(slot='label')
                                span.label {{ $t("mensagens.operacao.formularioAtividade.produtoAtividade") }}

                            el-select.campo-extendido(
                                v-model='atividadesOperacaoForm.idProduto',
                                clearable,
                                filterable
                            )
                                el-option(
                                    v-for='option in produtosPecuariosOpcoes',
                                    :key='option.id',
                                    :label='option.nome',
                                    :value='option.id'
                                )
                                    | {{ option.nome }}
                    .col(style='flex-grow: 3')
                        el-form-item(prop='areaFinanciadaPecuaria')
                            template(slot='label')
                                span.label {{ $t("mensagens.operacao.formularioAtividade.areaFinanciadaHa") }}

                            money.campo-extendido.el-input__inner(
                                v-model='atividadesOperacaoForm.areaFinanciadaPecuaria',
                                v-bind='areaMask',
                                :placeholder="$t('mensagens.operacao.formularioAtividade.areaFinanciadaHa')"
                            )
                    .col(style='flex-grow: 3')
                        el-form-item(prop='quantidade')
                            template(slot='label')
                                span.label {{ $t("mensagens.operacao.formularioAtividade.quantidade") }}
                                span.label {{ " " + $t("mensagens.operacao.formularioAtividade.campoOpcionalLabel")}}

                            el-input(
                                v-model='atividadesOperacaoForm.quantidade',
                                :placeholder="$t('mensagens.operacao.formularioAtividade.quantidade')"
                            )

                    .col.alinhar-icone(style='flex-grow: 0.2')
                        el-tooltip(:content="$t('mensagens.operacao.acoes.adicionar')", placement='top')
                            i.el-icon-circle-plus-outline.icone(
                                @click='adicionarProdutoPecuaria'
                            )

        span.titulo(v-if='atividadeObrigatoria') {{ $t("mensagens.operacao.formularioAtividade.atividadesAdicionadas") }}
        el-table(
            :data='atividades',
            style='margin-bottom: 20px;',
            :empty-text="$t('mensagens.operacao.formularioAtividade.nenhumaAtividadeAdicionada')"
        )
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.tipo')")
                template(slot-scope='scope')
                    span
                        | {{ scope.row.tipo === 'agrícola' ? $t("mensagens.operacao.formularioAtividade.agricola") : $t("mensagens.operacao.formularioAtividade.pecuaria") }}
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.produto')")
                template(slot-scope='scope')
                    span(style='word-break: keep-all')
                        | {{ renderProduto(scope.row) }}
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.areaFinanciadaHa')")
                template(slot-scope='scope')
                    money.remove-estilos(
                        v-model='scope.row.areaFinanciada',
                        v-bind='areaMask',
                        readonly
                    )
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.quantidade')")
                template(slot-scope='scope')
                    span
                        | {{ scope.row.tipo === 'pecuária' && scope.row.quantidade && scope.row.quantidade !== 0 ? scope.row.quantidade.toString().replace('.', ',') : '-' }}
                    span(v-if='scope.row.tipo === "agrícola"')
                        | {{ '--' }}
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.inicioPlantio')")
                template(slot-scope='scope')
                    span
                        | {{ scope.row.tipo === 'agrícola' ? formatDataPtBr(scope.row.inicioPlantio) : '--' }}
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.fimPlantio')")
                template(slot-scope='scope')
                    span
                        | {{ scope.row.tipo === 'agrícola' ? formatDataPtBr(scope.row.fimPlantio) : '--' }}
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.inicioColheita')")
                template(slot-scope='scope')
                    span
                        | {{ scope.row.tipo === 'agrícola' ? formatDataPtBr(scope.row.inicioColheita) : '--' }}
            el-table-column(:label="$t('mensagens.operacao.formularioAtividade.fimColheita')")
                template(slot-scope='scope')
                    span
                        | {{ scope.row.tipo === 'agrícola' ? formatDataPtBr(scope.row.fimColheita) : '--' }}
            el-table-column
                template(slot-scope='scope')
                    .i.el-icon-delete.icone-lixeira(
                        @click='removerAtividade(scope.row.idProduto)'
                    )
</template>

<script>
import OperacaoService from '../../../services/OperacaoService';
import Card from '../../Card.vue';
import { Money } from 'v-money';

export default {
    name: 'FormularioAtividadesOperacao',

    emits: ['dadosAtividades'],

    props: {
        operacaoEditarOuClonar: {
            type: Object,
            required: false,
            default: null
        },
        atividadeObrigatoria: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    components: {
        Card,
        Money
    },

    data() {
        const validarProdutoNecessario = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.produtoAtividadeNecessario')));
            }
            callback();
        };
        const validarInicioPlantio = (rule, value, callback) => {
            if (!value && this.isDateMandatory) {
                return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.inicioPlantioNecessario')));
            }
            callback();
        };
        const validarFimPlantio = (rule, value, callback) => {
            if (!value && this.isDateMandatory) {
                return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.fimPlantioNecessario')));
            }
            if (this.atividadesOperacaoForm.inicioPlantio) {
                if (value && value < this.atividadesOperacaoForm.inicioPlantio) {
                    return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.dataFimPlantioMenor')));
                }
            }
            callback();
        };
        const validarFimColheita = (rule, value, callback) => {
            if (!value && this.isDateMandatory) {
                return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.fimColheitaNecessario')));
            }
            if (this.atividadesOperacaoForm.inicioColheita) {
                if (value && value < this.atividadesOperacaoForm.inicioColheita) {
                    return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.dataFimColheitaMenor')));
                }
            }
            callback();
        };
        const validarInicioColheita = (rule, value, callback) => {
            if (!value && this.isDateMandatory) {
                return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.inicioColheitaNecessario')));
            }
            if (this.atividadesOperacaoForm.fimPlantio) {
                if (value && value < this.atividadesOperacaoForm.fimPlantio) {
                    return callback(new Error(this.$t('mensagens.operacao.formularioAtividade.dataInicioColheitaMenor')));
                }
            }
            callback();
        };

        return {
            atividadesOperacaoRules: {
                idProduto: [
                    {
                        required: true,
                        validator: validarProdutoNecessario,
                        trigger: 'change'
                    }
                ],
                areaFinanciadaAgricola: [
                    {
                        required: true,
                        message: this.$t('mensagens.operacao.formularioAtividade.areaFinanciadaNecessaria'),
                        trigger: 'blur'
                    }
                ],
                areaFinanciadaPecuaria: [
                    {
                        required: true,
                        message: this.$t('mensagens.operacao.formularioAtividade.areaFinanciadaNecessaria'),
                        trigger: 'blur'
                    }
                ],
                inicioPlantio: [
                    {
                        required: true,
                        validator: validarInicioPlantio,
                        trigger: 'change'
                    }
                ],
                fimPlantio: [
                    {
                        required: true,
                        validator: validarFimPlantio,
                        trigger: 'change'
                    }
                ],
                inicioColheita: [
                    {
                        required: true,
                        validator: validarInicioColheita,
                        trigger: 'change'
                    }
                ],
                fimColheita: [
                    {
                        required: true,
                        validator: validarFimColheita,
                        trigger: 'change'
                    }
                ]
            },
            atividadesOperacaoForm: {
                tipo: '',
                idProduto: null,
                areaFinanciadaAgricola: '',
                areaFinanciadaPecuaria: '',
                quantidade: null,
                inicioPlantio: null,
                fimPlantio: null,
                inicioColheita: null,
                fimColheita: null
            },
            atividades: [],
            produtosAgricolasOpcoes: [],
            produtosPecuariosOpcoes: [],
            areaMask: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            isDateMandatory: true
        };
    },

    async mounted() {
        try {
            const { data } = await OperacaoService.buscarProdutos('agricola');
            this.produtosAgricolasOpcoes = data.itens;
        } catch {
            this.$notify.error({
                message: this.$t('mensagens.operacao.notificacao.produtosAgricolasErro')
            });
        }
        try {
            const { data } = await OperacaoService.buscarProdutos('pecuaria');
            this.produtosPecuariosOpcoes = data.itens;
        } catch {
            this.$notify.error({
                message: this.$t('mensagens.operacao.notificacao.produtosPecuariosErro')
            });
        }

        setTimeout(this.verificarEdicao, 1000);

    },

    watch: {
        'atividadesOperacaoForm.tipo'() {
            this.resetarCampos();
        },

        '$i18n.locale': function(newLocale) {
            const itemNecessario = document.querySelector('.el-form-item__error');
            if (itemNecessario) {
                this.$refs.atividadesOperacaoForm.validate(valid => {
                    if (!valid) {
                        this.verificarObrigatoriedade();
                    }
                });
            }
        },

        atividadeObrigatoria: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.verificarObrigatoriedade();
            }
        }
    },

    methods: {
        verificarObrigatoriedade() {
            if (this.atividadeObrigatoria === true) {
                this.atividadesOperacaoForm.tipo = 'agricola';
            } else {
                this.atividadesOperacaoForm.tipo = '';
            }
        },

        atividadeDeMesmoTipo(tipo) {
            return this.atividades.length === 0 || tipo === this.atividades[0].tipo;
        },

        desativarOpcao(tipo) {
            return !(this.atividades.length === 0 || tipo === this.atividades[0].tipo);
        },

        adicionarProdutoAgricola() {
            this.$refs.atividadesOperacaoForm.validate(valid => {
                if (valid) {
                    this.atividades.push({
                        tipo: 'agrícola',
                        idProduto: this.atividadesOperacaoForm.idProduto,
                        areaFinanciada:
                            this.atividadesOperacaoForm.areaFinanciadaAgricola,
                        inicioPlantio:
                            this.atividadesOperacaoForm.inicioPlantio,
                        fimPlantio: this.atividadesOperacaoForm.fimPlantio,
                        inicioColheita:
                            this.atividadesOperacaoForm.inicioColheita,
                        fimColheita: this.atividadesOperacaoForm.fimColheita,
                        quantidade: null
                    });
                    this.resetarCampos();
                }
            });
            this.atualizarListaAtividades();
        },
        adicionarProdutoPecuaria() {
            this.$refs.atividadesOperacaoForm.validate(valid => {
                if (valid) {
                    this.atividades.push({
                        tipo: 'pecuária',
                        idProduto: this.atividadesOperacaoForm.idProduto,
                        areaFinanciada:
                            this.atividadesOperacaoForm.areaFinanciadaPecuaria,
                        quantidade: this.atividadesOperacaoForm.quantidade,
                        inicioPlantio: null,
                        fimPlantio: null,
                        inicioColheita: null,
                        fimColheita: null
                    });
                    this.resetarCampos();
                }
            });
            this.atualizarListaAtividades();
        },
        resetarCampos() {
            this.$refs.atividadesOperacaoForm.resetFields();
            this.atividadesOperacaoForm.quantidade = null;
            setTimeout(() => {
                this.$refs.atividadesOperacaoForm.clearValidate();
            }, 200);
        },
        renderProduto(produto) {
            if (produto.nomeProduto) {
                return produto.nomeProduto;
            } else if (produto.tipo === 'agrícola') {
                return this.produtosAgricolasOpcoes.find(
                    p => p.id === produto.idProduto
                ).nome;
            } else {
                return this.produtosPecuariosOpcoes.find(
                    p => p.id === produto.idProduto
                ).nome;
            }
        },
        formatDataPtBr(data) {
            return data ? new Date(data).toLocaleDateString('pt-BR') : '--';
        },
        removerAtividade(idProduto) {
            const index = this.atividades.findIndex(
                atividade => atividade.idProduto === idProduto
            );
            this.atividades.splice(index, 1);
            this.atualizarListaAtividades();
        },
        atualizarListaAtividades() {
            this.$emit('dadosAtividades', this.atividades);
        },

        verificarEdicao() {
            if (this.operacaoEditarOuClonar !== null) {
                this.atividades = this.operacaoEditarOuClonar.atividades;

                this.atividades.forEach(atividade => {
                    if (atividade.inicioPlantio !== null) {
                        let dataString =
                            atividade.inicioPlantioFormatado.split('/');
                        atividade.inicioPlantio = new Date(
                            `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                        );
                    }

                    if (atividade.inicioColheita !== null) {
                        let dataString =
                            atividade.inicioColheitaFormatado.split('/');
                        atividade.inicioColheita = new Date(
                            `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                        );
                    }

                    if (atividade.fimPlantio !== null) {
                        let dataString =
                            atividade.fimPlantioFormatado.split('/');
                        atividade.fimPlantio = new Date(
                            `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                        );
                    }

                    if (atividade.fimColheita !== null) {
                        let dataString =
                            atividade.fimColheitaFormatado.split('/');
                        atividade.fimColheita = new Date(
                            `${dataString[2]}/${dataString[1]}/${dataString[0]}`
                        );
                    }
                });

                this.atualizarListaAtividades();
                this.atividadesOperacaoForm.tipo = this.operacaoEditarOuClonar?.atividades[0]?.tipo === 'pecuária' ? 'pecuaria' : 'agricola';
            }
        },
        
        changeProduct() {
            this.isDateMandatory = this.produtosAgricolasOpcoes.filter(
                p => p.id === this.atividadesOperacaoForm.idProduto
            )[0].preenchimentoDatasObrigatorio;
            
            this.atividadesOperacaoRules.inicioPlantio[0].required = this.isDateMandatory;
            this.atividadesOperacaoRules.fimPlantio[0].required = this.isDateMandatory;
            this.atividadesOperacaoRules.inicioColheita[0].required = this.isDateMandatory;
            this.atividadesOperacaoRules.fimColheita[0].required = this.isDateMandatory;
        }
    }
};
</script>

<style lang="scss">
#atividades-operacao {
    .titulo {
        font-size: 14px;
        font-weight: 700;
        color: dimgray;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .label {
        font-size: 14px;
        color: var(--primary);
    }

    .sem-margem {
        margin: 0;
    }

    .espaco-radio {
        padding-left: 15px;
    }

    .campo-extendido {
        width: 100% !important;
    }

    .icone {
        font-size: 25px;
        cursor: pointer;
        margin: 0;
        margin-top: 30px;
        padding: 0;
        color: var(--primary);
    }

    .icone-lixeira {
        font-size: 22px;
        cursor: pointer;
        color: #900000;
    }

    .alinhar-icone {
        display: flex;
        align-items: center;
    }

    .remove-estilos {
        all: unset;
        caret-color: transparent;
    }

    .el-table thead {
        font-size: 15px;
        color: var(--primary);
    }

    .el-form-item {
        margin-bottom: 18px !important;
    }

    th {
        font-weight: 400;
    }

    #empty {
        font-size: 14px;
        color: dimgray;
        font-style: italic;
    }
}
</style>
